/*
 * BLANCA カスタム JS (theme.liquid で読み込み)
 */

/*
 * レビュー投稿ページ (sections/blanca-review-products.liquid) - 2026-10-16
 * カードのボタンから、レビューアプリの投稿フォーム (商品ページと同じモーダル) をこのページのまま開く。
 * アプリは .wc_product_review_section[data-product_id] に商品ごとのレビュー欄を描画し、
 * その中の投稿ボタンがモーダルを body 直下に開く。そこで押された商品の分だけ非表示のレビュー欄を作り、投稿ボタンを押す。
 * アプリの読み込みや描画を待ちきれなかったときは、商品ページのレビュー欄へ移って投稿フォームを開く (アプリ標準のパラメータ)。
 */
(() => {
  const WAIT_MS = 10000;

  const waitFor = (check, timeout) => new Promise((resolve) => {
    const startedAt = Date.now();
    const tick = () => {
      const result = check();
      if (result) return resolve(result);
      if (Date.now() - startedAt > timeout) return resolve(null);
      setTimeout(tick, 100);
    };
    tick();
  });

  const getMount = (button) => {
    const mounts = button.closest('.blanca-review-products').querySelector('.blanca-review-products__mounts');
    const productId = button.dataset.productId;
    let mount = mounts.querySelector(`[data-product_id="${productId}"]`);

    if (!mount) {
      mount = document.createElement('div');
      mount.className = 'wc_product_review_section';
      mount.dataset.product_id = productId;
      mount.dataset.handle = button.dataset.productHandle;
      mounts.appendChild(mount);
    }

    return mount;
  };

  const openReviewForm = async (button) => {
    const mount = getMount(button);
    const appReady = await waitFor(() => typeof window.rivyoProductReviewSection === 'function', WAIT_MS);

    if (appReady) {
      window.rivyoProductReviewSection();
    }

    // 投稿ボタンはレイアウトによって data-type が付かないが、アクション欄の先頭 (質問ボタンより前) に固定で置かれる
    const opener = appReady && await waitFor(() => (
      mount.querySelector('.wcRivyoFeedback[data-type="Review"]') || mount.querySelector('.wc_review_summary_action .wcRivyoFeedback')
    ), WAIT_MS);

    if (opener) {
      opener.click();
    } else {
      window.location.href = `${button.dataset.productUrl}?wc_review_section_redirect=true#wc_review_section`;
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-blanca-review-open]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    const buttons = document.querySelectorAll('[data-blanca-review-open]');
    buttons.forEach((item) => { item.disabled = true; });
    button.setAttribute('aria-busy', 'true');

    try {
      await openReviewForm(button);
    } finally {
      button.removeAttribute('aria-busy');
      buttons.forEach((item) => { item.disabled = false; });
    }
  });
})();

/*
 * レビュー投稿完了のメッセージ (snippets/blanca-review-thanks.liquid) - 2026-10-16
 * レビューアプリは投稿に成功すると、画面下に .rivyo_toast.success を出してモーダルを閉じる。
 * ただし返ってくるメッセージが空のため、小さな緑の帯が一瞬出るだけで、お客様には完了が伝わらない。
 * そこで .rivyo_toast.success が出たら、アプリの帯を隠して BLANCA のメッセージを開く。
 * 質問 (Q&A) の投稿でも同じ帯が出るので、直前に操作したモーダルが評価 (星) 付きのレビューフォームだったときだけ開く。
 */
(() => {
  const dialog = document.getElementById('blanca-review-thanks');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  let lastFormWasReview = false;

  document.addEventListener('click', (event) => {
    const modal = event.target.closest('.wc_rivyo_appended_modal');
    if (modal) {
      lastFormWasReview = Boolean(modal.querySelector('[name="wc_rating"]'));
    }
  }, true);

  const showThanks = (toast) => {
    if (!lastFormWasReview) return;
    lastFormWasReview = false;
    toast.style.display = 'none';
    if (!dialog.open) dialog.showModal();
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        const toast = node.matches('.rivyo_toast.success') ? node : node.querySelector('.rivyo_toast.success');
        if (toast) showThanks(toast);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // 背景 (ダイアログの外側) を押しても閉じる
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
})();
